export default __webpack_public_path__ + "static/media/flag-argentina.aa1cc1da.svg";